import { Toast } from '@fattureincloud/fic-design-system'
import { IconName } from '@fortawesome/fontawesome-common-types'
import { findIconDefinition, IconProp, library } from '@fortawesome/fontawesome-svg-core'
import { fal, faSpinner } from '@fortawesome/pro-light-svg-icons'

import { locale } from '../locales/locale'
import { httpRequest } from './network'

library.add(fal)
export const isNumeric = (value: string): boolean => {
  return /^-?\d+$/.test(value)
}

export type ValueOf<T> = T[keyof T]

export type RecursivePartial<T> = {
  [P in keyof T]?: T[P] extends (infer U)[]
  ? RecursivePartial<U>[]
  : T[P] extends Record<string, unknown>
  ? RecursivePartial<T[P]>
  : T[P]
}

export const getIcon = (icon: string): IconProp => {
  if (icon === 'bar-chart') {
    icon = 'chart-bar'
  } else {
    if (icon === 'clock-o') {
      icon = 'clock'
    }
  }
  if (!icon || icon === '' || icon.length < 3 || !findIconDefinition({ prefix: 'fal', iconName: icon as IconName })) return undefined
  return ['fal', icon as IconName]
}

export const printArticlePdf = (id: string | number): void => {
  const toastPdf = Toast.info(locale('Generazione PDF in corso') + '...', { autoClose: false, icon: { color: "white", icon: faSpinner, spin: true } })
  httpRequest({
    method: 'GET',
    path: `help/article/print/${id}`,
    responseType: 'blob',
    getResponse: (response) => {
      const file = new Blob([response.data], { type: 'application/pdf' })
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL)
      Toast.dismiss(toastPdf)
    },
    onError: (res) => {
      Toast.dismiss(toastPdf)
      Toast.error(locale('Error'), { content: res.message })
    },
  })
}


export const isDic = (): boolean => {
  return window.location.origin.endsWith('.dipendentincloud.it') ? true : false
}

//TODO can be read from .env
export const gtmId_DIC = 'GTM-5RGXSJQ'
export const gtmId_FIC = 'GTM-TPR8RR7'